module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image43.7ac51096.webp";